export enum OrderStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  CANCELED = "CANCELED",
  FULFILLED = "FULFILLED",
  SUSPENDED = "SUSPENDED",
  EXPIRED = "EXPIRED",
}
